import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'oc-ellipsis',
  templateUrl: './ellipsis.component.html',
  styleUrls: ['./ellipsis.component.scss']
})
export class EllipsisComponent implements OnInit {
  @ViewChild('contentTruncate', { static: false }) contentTruncate: ElementRef;
  @ViewChild('contentFull', { static: false }) contentFull: ElementRef;
  @Input() lines = 4;
  @Input() expandable = false;
  @Input() externalLink = null;
  maxHeight = 120;
  truncated = true;
  testCompleted = false;
  truncate;
  full;
  contentFullHTML;

  constructor(private router: Router) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.setMaxHeight();

    this.truncate = this.contentTruncate.nativeElement;
    this.full = this.contentFull.nativeElement;

    // Duplicate content
    this.contentFullHTML = this.truncate.cloneNode(true);
    this.full.appendChild(this.contentFullHTML);

    if (this.expandable) {
      this.truncate.innerHTML = this.truncate.innerHTML.replaceAll(/<br\s*\\*>/g, ' ');
      // [...this.truncate.querySelectorAll('br')].forEach(br => br.remove());

      if (this.contentTruncate.nativeElement.offsetHeight > this.maxHeight) {

        // Remove words from this.truncate until it's the right height
        while (this.contentTruncate.nativeElement.offsetHeight > this.maxHeight) {
          this.truncate.innerHTML = this.truncate.innerHTML.replace(/(\W*\s(\S)*$)/g, '');
        }

        this.testCompleted = true;

        // Remove any periods and add ellipsis
        if (this.truncate.lastChild) {
          this.truncate.lastChild.innerText = this.truncate.lastChild.innerText.replaceAll(/\.+$/g, '');
          this.truncate.lastChild.innerText += '...';
        }

        // Add read more button if applicable
        if (this.expandable) {
          this.truncate.lastChild.innerHTML += '<a class="spacer">Read More</a>'
          document.querySelector('.spacer').addEventListener('click', () => this.toggleTruncate());
        }
      }
    }
  }
  ngAfterViewChecked() {
    if (!this.expandable) {
      if (this.truncate.querySelector('br')) {
        this.truncate.innerHTML = this.truncate.innerHTML.replaceAll(/<br\s*\\*>/g, ' ');
      }
      if (this.truncate.querySelector('p')) {
        this.truncate.innerHTML = this.truncate.innerHTML.replaceAll(/<\/?p[^>]*>/g, ' ');
      }
    }
  }

  setMaxHeight() {
    const truncate = this.contentTruncate.nativeElement;
    const lineHeight = parseInt(window.getComputedStyle(truncate)['line-height']);
    this.maxHeight = (lineHeight * this.lines) + 16
  }
  toggleTruncate() {
    this.truncated = !this.truncated;
  }

}
